import React, { useState } from "react";
import { Box, Stack, styled, Tooltip, Typography } from "convertupleads-theme";

const Color = styled(Box)(({ theme }) => ({
  width: 40,
  height: 40,
  borderRadius: "50%",
  // backgroundColor: color ? color : theme.palette.primary.main,
  cursor: "pointer",
  "&:focus": {
    border: `2px solid ${theme.palette.common.black}`,
  },
}));

const ColorBox = ({ colorCode, color }) => {
  const [clicked, setClicked] = useState(false);

  const clickHandler = () => {
    navigator.clipboard.writeText(color);
    setClicked(true);
  };

  return (
    <Stack spacing={1} alignItems={"center"} sx={{ textAlign: "center" }}>
      <Tooltip
        title={clicked ? "Clicked" : "click to copy color code"}
        placement={"top"}
      >
        <Color bgcolor={color} onClick={clickHandler} tabIndex={0} />
      </Tooltip>
      <Stack direction={"column"} mt={1}>
        <Typography variant={"caption"} color={"text.secondary"}>
          {colorCode}
        </Typography>
        <Typography variant={"caption"} color={"text.primary"}>
          {color}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default ColorBox;
